import { h } from 'preact'

export const newPatientIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg">
        <defs />
        <g fill="none" fillRule="evenodd">
            <path
                fill="#ECF0F1"
                d="M29.707 65.152l-12.195 6.657c-.716.39-1.36.872-1.958 1.395 7.112 6 16.29 9.62 26.32 9.62a40.679 40.679 0 0026.164-9.485 10.983 10.983 0 00-2.15-1.444l-13.06-6.535a4.985 4.985 0 01-2.752-4.459v-5.128c.365-.419.786-.956 1.235-1.59 1.778-2.516 3.125-5.284 4.058-8.19 1.675-.516 2.909-2.065 2.909-3.905v-5.473a4.084 4.084 0 00-1.367-3.034v-7.914S58.534 13.35 41.873 13.35c-16.662 0-15.038 12.317-15.038 12.317v7.914a4.08 4.08 0 00-1.368 3.034v5.473c0 1.442.759 2.71 1.891 3.444 1.365 5.953 4.945 10.24 4.945 10.24v5.001a4.987 4.987 0 01-2.596 4.379"
            />
            <path
                fill="#556080"
                d="M42.572 1.006C20.002.62 1.392 18.62 1.006 41.213.787 54.023 6.491 65.535 15.572 73.19c.593-.519 1.23-.995 1.94-1.382l12.195-6.657a4.989 4.989 0 002.596-4.379v-5s-3.58-4.287-4.945-10.24a4.108 4.108 0 01-1.89-3.446v-5.473c0-1.205.534-2.28 1.367-3.033v-7.913S25.21 13.35 41.873 13.35c16.66 0 15.038 12.317 15.038 12.317v7.913a4.083 4.083 0 011.367 3.033v5.473c0 1.841-1.234 3.39-2.91 3.907-.932 2.904-2.279 5.672-4.057 8.187a19.795 19.795 0 01-1.236 1.592v5.129a4.985 4.985 0 002.754 4.458l13.059 6.535c.783.394 1.49.888 2.144 1.44C76.839 65.98 82.528 54.99 82.74 42.61 83.125 20.02 65.14 1.392 42.572 1.006"
            />
            <path
                fill="#71C386"
                d="M92 70.474C92 80.704 83.713 89 73.492 89c-10.222 0-18.509-8.295-18.509-18.526s8.287-18.527 18.509-18.527C83.712 51.947 92 60.243 92 70.474"
            />
            <path
                fill="#FFF"
                d="M82.746 68.93h-7.712v-7.72a1.543 1.543 0 10-3.085 0v7.72h-7.712c-.851 0-1.542.69-1.542 1.544 0 .853.69 1.544 1.542 1.544h7.712v7.719a1.543 1.543 0 103.085 0v-7.72h7.712a1.543 1.543 0 000-3.088"
            />
            <path
                stroke="#231317"
                strokeWidth="2"
                d="M90.458 68.93c0 10.231-8.288 18.526-18.509 18.526S53.441 79.161 53.441 68.93s8.287-18.526 18.508-18.526c10.221 0 18.509 8.295 18.509 18.526z"
            />
            <path
                stroke="#0D1D21"
                strokeWidth="2"
                d="M53.44 68.93c0-10.231 8.288-18.526 18.51-18.526 3.388 0 6.554.927 9.286 2.518a40.952 40.952 0 001.51-11.01C82.746 19.316 64.447 1 41.873 1 19.299 1 1 19.316 1 41.912s18.299 40.913 40.873 40.913a40.741 40.741 0 0015.183-2.928 18.432 18.432 0 01-3.615-10.967z"
            />
            <path
                stroke="#0D1D21"
                strokeWidth="2"
                d="M53.44 68.93c0-1.065.11-2.104.283-3.12l-.893-.451a4.982 4.982 0 01-2.755-4.457v-5.129c.367-.418.788-.957 1.236-1.592 1.78-2.515 3.126-5.283 4.058-8.187 1.675-.517 2.909-2.065 2.909-3.907v-5.473c0-1.204-.534-2.28-1.367-3.032v-7.914S58.535 13.35 41.873 13.35 26.835 25.668 26.835 25.668v7.914a4.077 4.077 0 00-1.367 3.032v5.473c0 1.443.758 2.712 1.89 3.446 1.366 5.953 4.944 10.24 4.944 10.24v5a4.99 4.99 0 01-2.595 4.379L17.51 71.809c-.716.39-1.359.872-1.957 1.396 7.112 5.998 16.29 9.62 26.319 9.62a40.606 40.606 0 0015.168-2.948 18.442 18.442 0 01-3.6-10.947z"
            />
        </g>
    </svg>
)

export const existingPatientIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg">
        <defs />
        <g fill="none" fillRule="evenodd">
            <path
                fill="#ECF0F1"
                d="M29.707 65.218l-12.195 6.664c-.716.39-1.36.873-1.96 1.397 7.114 6.006 16.293 9.63 26.321 9.63 9.955 0 19.075-3.569 26.165-9.496a10.937 10.937 0 00-2.15-1.445l-13.06-6.542a4.988 4.988 0 01-2.752-4.463V55.83c.365-.419.786-.956 1.235-1.592 1.778-2.517 3.125-5.288 4.06-8.197 1.673-.517 2.907-2.068 2.907-3.91v-5.478a4.084 4.084 0 00-1.367-3.037v-7.922s1.623-12.33-15.038-12.33c-16.662 0-15.038 12.33-15.038 12.33v7.922a4.085 4.085 0 00-1.368 3.037v5.478a4.11 4.11 0 001.891 3.448c1.365 5.96 4.945 10.251 4.945 10.251v5.006a4.996 4.996 0 01-2.596 4.383"
            />
            <path
                fill="#556080"
                d="M42.572 1.006C20 .62 1.392 18.638 1.006 41.254.787 54.077 6.491 65.601 15.571 73.265c.594-.519 1.232-.995 1.94-1.383l12.196-6.664a4.998 4.998 0 002.596-4.383V55.83s-3.58-4.291-4.945-10.25a4.111 4.111 0 01-1.891-3.45V36.65c0-1.205.535-2.282 1.368-3.035v-7.922s-1.624-12.33 15.038-12.33 15.038 12.33 15.038 12.33v7.922a4.085 4.085 0 011.368 3.035v5.479c0 1.844-1.235 3.394-2.909 3.912-.934 2.907-2.28 5.678-4.06 8.195a19.812 19.812 0 01-1.235 1.593v5.134a4.991 4.991 0 002.754 4.464l13.059 6.542a10.94 10.94 0 012.144 1.44c8.807-7.361 14.496-18.363 14.708-30.755.385-22.616-17.597-41.262-40.168-41.648"
            />
            <path
                fill="#B1D3EF"
                d="M92 66.682C92 77.35 83.367 86 72.72 86c-10.647 0-19.28-8.65-19.28-19.318 0-10.668 8.633-19.318 19.28-19.318 10.647 0 19.28 8.65 19.28 19.318"
            />
            <path
                fill="#556080"
                d="M87.671 67.485A1.53 1.53 0 0085.86 68.7c-1.265 6.441-6.79 11.116-13.138 11.116-5.17 0-9.791-3.098-12.014-7.727h8.158V69H56.526v12.363h3.085V76.2c3.046 4.106 7.843 6.708 13.11 6.708 7.817 0 14.615-5.722 16.166-13.609a1.543 1.543 0 00-1.216-1.814M85.83 51.997v5.165c-3.049-4.105-7.844-6.71-13.11-6.71-7.816 0-14.617 5.724-16.165 13.61-.165.838.38 1.65 1.215 1.815a1.529 1.529 0 001.81-1.218c1.267-6.442 6.792-11.117 13.14-11.117 5.169 0 9.791 3.1 12.014 7.728h-8.158v3.09h12.339V51.998h-3.084z"
            />
            <path
                stroke="#0D1D21"
                strokeLinecap="round"
                strokeWidth="2"
                d="M82.746 41.955C82.746 19.335 64.447 1 41.873 1 19.299 1 1 19.335 1 41.955c0 22.619 18.299 40.954 40.873 40.954"
            />
            <path
                stroke="#0D1D21"
                strokeLinecap="round"
                strokeWidth="2"
                d="M55.37 46.04c1.674-.518 2.91-2.068 2.91-3.91v-5.479a4.088 4.088 0 00-1.369-3.036v-7.922s1.624-12.33-15.038-12.33-15.038 12.33-15.038 12.33v7.922a4.088 4.088 0 00-1.368 3.036v5.48c0 1.443.759 2.714 1.89 3.447 1.367 5.96 4.947 10.251 4.947 10.251v5.006a4.994 4.994 0 01-2.597 4.383L17.51 71.883a10.96 10.96 0 00-1.957 1.396c7.112 6.005 16.29 9.63 26.319 9.63"
            />
        </g>
    </svg>
)

export const calendarIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg">
        <defs />
        <g fill="none" fillRule="evenodd">
            <path fill="#FF5364" d="M69.148 6.931v5.931h-10.37V6.931H23.222v5.931h-10.37V6.931H1v16.31h80V6.931z" />
            <path fill="#F1E6B0" d="M12.852 23.241H1V87h80V23.241H23.222z" />
            <path
                fill="#D8C460"
                d="M55.815 46.966h10.37v-10.38h-10.37v10.38zm0 13.344h10.37V49.931h-10.37v10.38zm0 13.345h10.37v-10.38h-10.37v10.38zm-13.334 0h10.37v-10.38h-10.37v10.38zm-13.333 0h10.37v-10.38h-10.37v10.38zm-13.333 0h10.37v-10.38h-10.37v10.38zm0-13.345h10.37V49.931h-10.37v10.38zm0-13.344h10.37v-10.38h-10.37v10.38zm13.333 0h10.37v-10.38h-10.37v10.38zm0 13.344h10.37V49.931h-10.37v10.38zm13.333 0h10.37V49.931h-10.37v10.38zm0-13.344h10.37v-10.38h-10.37v10.38zM55.815 33.62H12.852V76.62H69.148v-43H55.815z"
            />
            <path fill="#35495E" d="M12.852 12.862h10.37V1h-10.37zM58.778 12.862h10.37V1h-10.37z" />
            <path fill="#25C3AB" d="M42.481 60.31h10.371V49.931H42.481z" />
            <g stroke="#231117" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                <path d="M12.852 12.862h10.37V1h-10.37zM58.778 12.862h10.37V1h-10.37z" />
                <path d="M69.148 6.931v5.931h-10.37V6.931H23.222v5.931h-10.37V6.931H1v16.31h80V6.931z" />
                <path d="M69.148 6.931v5.931h-10.37V6.931H23.222v5.931h-10.37V6.931H1V87h80V6.931z" />
            </g>
        </g>
    </svg>
)

export const successIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg">
        <defs />
        <g fill="none" fillRule="evenodd" strokeWidth="2">
            <path
                fill="#3DA50C"
                stroke="#F9F9F9"
                d="M81 41c0 22.091-17.909 40-40 40S1 63.091 1 41 18.909 1 41 1s40 17.909 40 40"
            />
            <path stroke="#FFF" strokeLinecap="round" strokeLinejoin="round" d="M61.8 25L36.2 53.8 20.2 41" />
        </g>
    </svg>
)

export const selectedLocationIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 24" width="17pt" height="24pt">
        <g>
            <path
                d=" M 8.444 0 C 13.105 0 16.889 3.784 16.889 8.444 C 16.889 8.898 16.853 9.343 16.784 9.778 L 16.736 10.049 C 16.399 13.58 10.781 18.176 8.444 24 C 6.108 18.176 0.49 13.58 0.153 10.049 L 0.105 9.778 C 0.036 9.343 0 8.898 0 8.444 C 0 3.784 3.784 0 8.444 0 L 8.444 0 Z  M 4.889 8.444 C 4.889 6.482 6.482 4.889 8.444 4.889 C 10.407 4.889 12 6.482 12 8.444 C 12 10.407 10.407 12 8.444 12 C 6.482 12 4.889 10.407 4.889 8.444 Z "
                fillRule="evenodd"
                fill="rgb(61,165,12)"
                vectorEffect="non-scaling-stroke"
                strokeWidth="1"
                stroke="rgb(255,255,255)"
                strokeLinejoin="miter"
                strokeLinecap="square"
                strokeMiterlimit="3"
            />
        </g>
    </svg>
)

export const locationIcon = (isEnabled: boolean) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 24" width="17pt" height="24pt">
        <g>
            <path
                d=" M 8.444 0 C 13.105 0 16.889 3.784 16.889 8.444 C 16.889 8.898 16.853 9.343 16.784 9.778 L 16.736 10.049 C 16.399 13.58 10.781 18.176 8.444 24 C 6.108 18.176 0.49 13.58 0.153 10.049 L 0.105 9.778 C 0.036 9.343 0 8.898 0 8.444 C 0 3.784 3.784 0 8.444 0 L 8.444 0 Z  M 4.889 8.444 C 4.889 6.482 6.482 4.889 8.444 4.889 C 10.407 4.889 12 6.482 12 8.444 C 12 10.407 10.407 12 8.444 12 C 6.482 12 4.889 10.407 4.889 8.444 Z "
                fillRule="evenodd"
                fill={isEnabled ? 'rgb(233,65,53)' : 'grey'}
                vectorEffect="non-scaling-stroke"
                strokeWidth="1"
                stroke="rgb(255,255,255)"
                strokeLinejoin="miter"
                strokeLinecap="square"
                strokeMiterlimit="3"
            />
        </g>
    </svg>
)

export const errorIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <g>
            <path
                fill="rgb(255,255,255)"
                d="M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
            />
        </g>
    </svg>
)

export const bookingErrorIcon = () => (
    <svg width="82px" height="82px" viewBox="0 0 82 82" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <title>large-error-outline</title>
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="$large-booked" transform="translate(-906.000000, -474.000000)">
                <g id="large-error-outline" transform="translate(907.000000, 475.000000)">
                    <g id="Group-5" fill="#C82323" stroke="#F9F9F9" stroke-width="2">
                        <path
                            d="M80,40 C80,62.0912 62.0912,80 40,80 C17.9088,80 0,62.0912 0,40 C0,17.9088 17.9088,0 40,0 C62.0912,0 80,17.9088 80,40"
                            id="Fill-1"
                        ></path>
                    </g>
                    <circle id="Oval" fill="#FFFFFF" cx="39.6796875" cy="39.6796875" r="32.6910798"></circle>
                    <path
                        d="M40,74 C49.3646322,74 57.372457,70.6744914 64.0234742,64.0234742 C70.6744914,57.372457 74,49.3646322 74,40 C74,30.6353678 70.6744914,22.627543 64.0234742,15.9765258 C57.372457,9.32550861 49.3646322,6 40,6 C30.6353678,6 22.600939,9.35211268 15.8967136,16.056338 C9.29890454,22.6541471 6,30.6353678 6,40 C6,49.3646322 9.32550861,57.372457 15.9765258,64.0234742 C22.627543,70.6744914 30.6353678,74 40,74 Z M43,43 L36,43 L36,23 L43,23 L43,43 Z M43,57 L36,57 L36,50 L43,50 L43,57 Z"
                        id="error"
                        fill="#C82323"
                        fill-rule="nonzero"
                    ></path>
                </g>
            </g>
        </g>
    </svg>
)

export const apptCancelIcon = () => (
    <svg
        width="68px"
        height="71px"
        viewBox="0 0 68 71"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <title>icon-cancel</title>
        <defs>
            <polygon id="path-1" points="0 0 9.71428571 0 9.71428571 12.1193336 0 12.1193336"></polygon>
            <polygon id="path-3" points="0 0 9.71428571 0 9.71428571 12.1193336 0 12.1193336"></polygon>
            <polygon id="path-5" points="0 0 12.1428571 0 12.1428571 12.1193336 0 12.1193336"></polygon>
            <polygon id="path-7" points="0 70.2921348 68 70.2921348 68 0 0 0"></polygon>
        </defs>
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="icon" transform="translate(-341.000000, -472.000000)">
                <g id="icon-cancel" transform="translate(341.000000, 472.000000)">
                    <polygon
                        id="Fill-1"
                        fill="#25C3AA"
                        points="49.7866033 6.11235955 18.214611 6.11235955 0 6.11235955 0 22.1573034 68 22.1573034 68 6.11235955"
                    ></polygon>
                    <g id="Group-32">
                        <path
                            d="M25.5,10.9074002 C25.5,12.2465866 24.4132143,13.331267 23.0714286,13.331267 C21.7296429,13.331267 20.6428571,12.2465866 20.6428571,10.9074002 C20.6428571,9.56821387 21.7296429,8.48353351 23.0714286,8.48353351 C24.4132143,8.48353351 25.5,9.56821387 25.5,10.9074002"
                            id="Fill-2"
                            fill="#485762"
                        ></path>
                        <path
                            d="M32.7857143,10.9074002 C32.7857143,12.2465866 31.6989286,13.331267 30.3571429,13.331267 C29.0153571,13.331267 27.9285714,12.2465866 27.9285714,10.9074002 C27.9285714,9.56821387 29.0153571,8.48353351 30.3571429,8.48353351 C31.6989286,8.48353351 32.7857143,9.56821387 32.7857143,10.9074002"
                            id="Fill-4"
                            fill="#485762"
                        ></path>
                        <path
                            d="M40.0714286,10.9074002 C40.0714286,12.2465866 38.9846429,13.331267 37.6428571,13.331267 C36.3010714,13.331267 35.2142857,12.2465866 35.2142857,10.9074002 C35.2142857,9.56821387 36.3010714,8.48353351 37.6428571,8.48353351 C38.9846429,8.48353351 40.0714286,9.56821387 40.0714286,10.9074002"
                            id="Fill-6"
                            fill="#485762"
                        ></path>
                        <path
                            d="M47.3571429,10.9074002 C47.3571429,12.2465866 46.2703571,13.331267 44.9285714,13.331267 C43.5867857,13.331267 42.5,12.2465866 42.5,10.9074002 C42.5,9.56821387 43.5867857,8.48353351 44.9285714,8.48353351 C46.2703571,8.48353351 47.3571429,9.56821387 47.3571429,10.9074002"
                            id="Fill-8"
                            fill="#485762"
                        ></path>
                        <path
                            d="M44.9285714,0 C43.5564286,0 42.3032857,0.473865943 41.2857143,1.24223169 C41.9341429,1.7330647 42.4745,2.34751492 42.8825,3.05407207 C43.4665714,2.65655792 44.1708571,2.42386672 44.9285714,2.42386672 C46.937,2.42386672 48.5714286,4.05512902 48.5714286,6.0596668 C48.5714286,8.06420457 46.937,9.69546687 44.9285714,9.69546687 C44.2570714,9.69546687 43.7142857,10.2372011 43.7142857,10.9074002 C43.7142857,11.5775994 44.2570714,12.1193336 44.9285714,12.1193336 C48.2763571,12.1193336 51,9.40096707 51,6.0596668 C51,2.71836652 48.2763571,0 44.9285714,0"
                            id="Fill-10"
                            fill="#BDC3C7"
                        ></path>
                        <path
                            d="M39.6885643,3.05407207 C39.1737071,3.94363115 38.8567786,4.96044324 38.8567786,6.0596668 L41.28535,6.0596668 C41.28535,4.81137544 40.6514929,3.70972801 39.6885643,3.05407207"
                            id="Fill-12"
                            fill="#95A5A5"
                        ></path>
                        <path
                            d="M32.40285,3.05407207 C31.8879929,3.94363115 31.5710643,4.96044324 31.5710643,6.0596668 L33.9996357,6.0596668 C33.9996357,4.81137544 33.3657786,3.70972801 32.40285,3.05407207"
                            id="Fill-14"
                            fill="#95A5A5"
                        ></path>
                        <g id="Group-18" transform="translate(34.000364, 0.000000)">
                            <mask id="mask-2" fill="white">
                                <use xlinkHref="#path-1"></use>
                            </mask>
                            <g id="Clip-17"></g>
                            <path
                                d="M8.8825,3.05407207 C8.47328571,2.34751492 7.93414286,1.7330647 7.28571429,1.24223169 C6.26692857,0.473865943 5.015,0 3.64285714,0 C2.27071429,0 1.01757143,0.473865943 0,1.24223169 C0.648428571,1.7330647 1.18757143,2.34751492 1.59678571,3.05407207 C2.18085714,2.65655792 2.88392857,2.42386672 3.64285714,2.42386672 C4.40057143,2.42386672 5.10485714,2.65655792 5.68771429,3.05407207 C6.65064286,3.70972801 7.28571429,4.81137544 7.28571429,6.0596668 C7.28571429,8.06420457 5.65128571,9.69546687 3.64285714,9.69546687 C2.97135714,9.69546687 2.42857143,10.2372011 2.42857143,10.9074002 C2.42857143,11.5775994 2.97135714,12.1193336 3.64285714,12.1193336 C6.99064286,12.1193336 9.71428571,9.40096707 9.71428571,6.0596668 C9.71428571,4.96044324 9.39735714,3.94363115 8.8825,3.05407207"
                                id="Fill-16"
                                fill="#BDC3C7"
                                mask="url(#mask-2)"
                            ></path>
                        </g>
                        <path
                            d="M25.1171357,3.05407207 C24.6022786,3.94363115 24.28535,4.96044324 24.28535,6.0596668 L26.7139214,6.0596668 C26.7139214,4.81137544 26.0800643,3.70972801 25.1171357,3.05407207"
                            id="Fill-19"
                            fill="#95A5A5"
                        ></path>
                        <g id="Group-23" transform="translate(26.714650, 0.000000)">
                            <mask id="mask-4" fill="white">
                                <use xlinkHref="#path-3"></use>
                            </mask>
                            <g id="Clip-22"></g>
                            <path
                                d="M8.8825,3.05407207 C8.47328571,2.34751492 7.93414286,1.7330647 7.28571429,1.24223169 C6.26692857,0.473865943 5.015,0 3.64285714,0 C2.27071429,0 1.01757143,0.473865943 0,1.24223169 C0.648428571,1.7330647 1.18757143,2.34751492 1.59678571,3.05407207 C2.18085714,2.65655792 2.88392857,2.42386672 3.64285714,2.42386672 C4.40057143,2.42386672 5.10485714,2.65655792 5.68771429,3.05407207 C6.65064286,3.70972801 7.28571429,4.81137544 7.28571429,6.0596668 C7.28571429,8.06420457 5.65128571,9.69546687 3.64285714,9.69546687 C2.97135714,9.69546687 2.42857143,10.2372011 2.42857143,10.9074002 C2.42857143,11.5775994 2.97135714,12.1193336 3.64285714,12.1193336 C6.99064286,12.1193336 9.71428571,9.40096707 9.71428571,6.0596668 C9.71428571,4.96044324 9.39735714,3.94363115 8.8825,3.05407207"
                                id="Fill-21"
                                fill="#BDC3C7"
                                mask="url(#mask-4)"
                            ></path>
                        </g>
                        <g id="Group-26" transform="translate(17.000364, 0.000000)">
                            <mask id="mask-6" fill="white">
                                <use xlinkHref="#path-5"></use>
                            </mask>
                            <g id="Clip-25"></g>
                            <path
                                d="M11.3110714,3.05407207 C10.9018571,2.34751492 10.3627143,1.7330647 9.71428571,1.24223169 C8.6955,0.473865943 7.44357143,0 6.07142857,0 C2.72364286,0 0,2.71836652 0,6.0596668 L2.42857143,6.0596668 C2.42857143,4.05512902 4.06178571,2.42386672 6.07142857,2.42386672 C6.82914286,2.42386672 7.53342857,2.65655792 8.11628571,3.05407207 C9.07921429,3.70972801 9.71428571,4.81137544 9.71428571,6.0596668 C9.71428571,8.06420457 8.07985714,9.69546687 6.07142857,9.69546687 C5.39992857,9.69546687 4.85714286,10.2372011 4.85714286,10.9074002 C4.85714286,11.5775994 5.39992857,12.1193336 6.07142857,12.1193336 C9.41921429,12.1193336 12.1428571,9.40096707 12.1428571,6.0596668 C12.1428571,4.96044324 11.8259286,3.94363115 11.3110714,3.05407207"
                                id="Fill-24"
                                fill="#BDC3C7"
                                mask="url(#mask-6)"
                            ></path>
                        </g>
                        <mask id="mask-8" fill="white">
                            <use xlinkHref="#path-7"></use>
                        </mask>
                        <g id="Clip-28"></g>
                        <polygon
                            id="Fill-27"
                            fill="#F0EDE0"
                            mask="url(#mask-8)"
                            points="0 70.2921348 68 70.2921348 68 21.8148005 0 21.8148005"
                        ></polygon>
                        <path
                            d="M51.3775214,45.6961897 C51.3775214,55.0729181 43.7615214,62.6741641 34.3665929,62.6741641 C24.9716643,62.6741641 17.3556643,55.0729181 17.3556643,45.6961897 C17.3556643,36.3194613 24.9716643,28.7182153 34.3665929,28.7182153 C43.7615214,28.7182153 51.3775214,36.3194613 51.3775214,45.6961897"
                            id="Fill-29"
                            fill="#FF0000"
                            mask="url(#mask-8)"
                        ></path>
                        <polyline
                            id="Stroke-30"
                            stroke="#FFFFFF"
                            stroke-width="1.121"
                            stroke-linecap="round"
                            mask="url(#mask-8)"
                            points="28.2422214 51.8083332 34.3658643 45.6965533 40.4907214 39.5835614"
                        ></polyline>
                        <polyline
                            id="Stroke-31"
                            stroke="#FFFFFF"
                            stroke-width="1.121"
                            stroke-linecap="round"
                            mask="url(#mask-8)"
                            points="28.2422214 39.5840462 34.3658643 45.6958261 40.4907214 51.808818"
                        ></polyline>
                    </g>
                </g>
            </g>
        </g>
    </svg>
)

export const apptConfirmIcon = () => (
    <svg
        width="68px"
        height="70px"
        viewBox="0 0 68 70"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <title>icon-confirm</title>
        <defs>
            <polygon id="path-1" points="0 0 9.71428571 0 9.71428571 12.0689655 0 12.0689655"></polygon>
            <polygon id="path-3" points="0 0 9.71428571 0 9.71428571 12.0689655 0 12.0689655"></polygon>
            <polygon id="path-5" points="0 0 12.1428571 0 12.1428571 12.0689655 0 12.0689655"></polygon>
            <polygon id="path-7" points="0 70 68 70 68 0 0 0"></polygon>
        </defs>
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="icon" transform="translate(-239.000000, -472.000000)">
                <g id="icon-confirm" transform="translate(239.000000, 472.000000)">
                    <g id="Group-33">
                        <polygon
                            id="Fill-1"
                            fill="#25C3AA"
                            points="49.7862 6.03436207 18.2147714 6.03436207 0.000485714286 6.03436207 0.000485714286 21.7252241 67.9992714 21.7252241 67.9992714 6.03436207"
                        ></polygon>
                        <g id="Group-32">
                            <path
                                d="M25.5,10.862069 C25.5,12.1956897 24.4132143,13.2758621 23.0714286,13.2758621 C21.7296429,13.2758621 20.6428571,12.1956897 20.6428571,10.862069 C20.6428571,9.52844828 21.7296429,8.44827586 23.0714286,8.44827586 C24.4132143,8.44827586 25.5,9.52844828 25.5,10.862069"
                                id="Fill-2"
                                fill="#485762"
                            ></path>
                            <path
                                d="M32.7857143,10.862069 C32.7857143,12.1956897 31.6989286,13.2758621 30.3571429,13.2758621 C29.0153571,13.2758621 27.9285714,12.1956897 27.9285714,10.862069 C27.9285714,9.52844828 29.0153571,8.44827586 30.3571429,8.44827586 C31.6989286,8.44827586 32.7857143,9.52844828 32.7857143,10.862069"
                                id="Fill-4"
                                fill="#485762"
                            ></path>
                            <path
                                d="M40.0714286,10.862069 C40.0714286,12.1956897 38.9846429,13.2758621 37.6428571,13.2758621 C36.3010714,13.2758621 35.2142857,12.1956897 35.2142857,10.862069 C35.2142857,9.52844828 36.3010714,8.44827586 37.6428571,8.44827586 C38.9846429,8.44827586 40.0714286,9.52844828 40.0714286,10.862069"
                                id="Fill-6"
                                fill="#485762"
                            ></path>
                            <path
                                d="M47.3571429,10.862069 C47.3571429,12.1956897 46.2703571,13.2758621 44.9285714,13.2758621 C43.5867857,13.2758621 42.5,12.1956897 42.5,10.862069 C42.5,9.52844828 43.5867857,8.44827586 44.9285714,8.44827586 C46.2703571,8.44827586 47.3571429,9.52844828 47.3571429,10.862069"
                                id="Fill-8"
                                fill="#485762"
                            ></path>
                            <path
                                d="M44.9285714,0 C43.5564286,0 42.3032857,0.471896552 41.2857143,1.23706897 C41.9341429,1.72586207 42.4745,2.33775862 42.8825,3.04137931 C43.4665714,2.64551724 44.1708571,2.4137931 44.9285714,2.4137931 C46.937,2.4137931 48.5714286,4.03827586 48.5714286,6.03448276 C48.5714286,8.03068966 46.937,9.65517241 44.9285714,9.65517241 C44.2570714,9.65517241 43.7142857,10.1946552 43.7142857,10.862069 C43.7142857,11.5294828 44.2570714,12.0689655 44.9285714,12.0689655 C48.2763571,12.0689655 51,9.36189655 51,6.03448276 C51,2.70706897 48.2763571,0 44.9285714,0"
                                id="Fill-10"
                                fill="#BDC3C7"
                            ></path>
                            <path
                                d="M39.6885643,3.04137931 C39.1737071,3.92724138 38.8567786,4.93982759 38.8567786,6.03448276 L41.28535,6.03448276 C41.28535,4.79137931 40.6514929,3.69431034 39.6885643,3.04137931"
                                id="Fill-12"
                                fill="#95A5A5"
                            ></path>
                            <path
                                d="M32.40285,3.04137931 C31.8879929,3.92724138 31.5710643,4.93982759 31.5710643,6.03448276 L33.9996357,6.03448276 C33.9996357,4.79137931 33.3657786,3.69431034 32.40285,3.04137931"
                                id="Fill-14"
                                fill="#95A5A5"
                            ></path>
                            <g id="Group-18" transform="translate(34.000364, 0.000000)">
                                <mask id="mask-2" fill="white">
                                    <use xlinkHref="#path-1"></use>
                                </mask>
                                <g id="Clip-17"></g>
                                <path
                                    d="M8.8825,3.04137931 C8.47328571,2.33775862 7.93414286,1.72586207 7.28571429,1.23706897 C6.26692857,0.471896552 5.015,0 3.64285714,0 C2.27071429,0 1.01757143,0.471896552 0,1.23706897 C0.648428571,1.72586207 1.18757143,2.33775862 1.59678571,3.04137931 C2.18085714,2.64551724 2.88392857,2.4137931 3.64285714,2.4137931 C4.40057143,2.4137931 5.10485714,2.64551724 5.68771429,3.04137931 C6.65064286,3.69431034 7.28571429,4.79137931 7.28571429,6.03448276 C7.28571429,8.03068966 5.65128571,9.65517241 3.64285714,9.65517241 C2.97135714,9.65517241 2.42857143,10.1946552 2.42857143,10.862069 C2.42857143,11.5294828 2.97135714,12.0689655 3.64285714,12.0689655 C6.99064286,12.0689655 9.71428571,9.36189655 9.71428571,6.03448276 C9.71428571,4.93982759 9.39735714,3.92724138 8.8825,3.04137931"
                                    id="Fill-16"
                                    fill="#BDC3C7"
                                    mask="url(#mask-2)"
                                ></path>
                            </g>
                            <path
                                d="M25.1171357,3.04137931 C24.6022786,3.92724138 24.28535,4.93982759 24.28535,6.03448276 L26.7139214,6.03448276 C26.7139214,4.79137931 26.0800643,3.69431034 25.1171357,3.04137931"
                                id="Fill-19"
                                fill="#95A5A5"
                            ></path>
                            <g id="Group-23" transform="translate(26.714650, 0.000000)">
                                <mask id="mask-4" fill="white">
                                    <use xlinkHref="#path-3"></use>
                                </mask>
                                <g id="Clip-22"></g>
                                <path
                                    d="M8.8825,3.04137931 C8.47328571,2.33775862 7.93414286,1.72586207 7.28571429,1.23706897 C6.26692857,0.471896552 5.015,0 3.64285714,0 C2.27071429,0 1.01757143,0.471896552 0,1.23706897 C0.648428571,1.72586207 1.18757143,2.33775862 1.59678571,3.04137931 C2.18085714,2.64551724 2.88392857,2.4137931 3.64285714,2.4137931 C4.40057143,2.4137931 5.10485714,2.64551724 5.68771429,3.04137931 C6.65064286,3.69431034 7.28571429,4.79137931 7.28571429,6.03448276 C7.28571429,8.03068966 5.65128571,9.65517241 3.64285714,9.65517241 C2.97135714,9.65517241 2.42857143,10.1946552 2.42857143,10.862069 C2.42857143,11.5294828 2.97135714,12.0689655 3.64285714,12.0689655 C6.99064286,12.0689655 9.71428571,9.36189655 9.71428571,6.03448276 C9.71428571,4.93982759 9.39735714,3.92724138 8.8825,3.04137931"
                                    id="Fill-21"
                                    fill="#BDC3C7"
                                    mask="url(#mask-4)"
                                ></path>
                            </g>
                            <g id="Group-26" transform="translate(17.000364, 0.000000)">
                                <mask id="mask-6" fill="white">
                                    <use xlinkHref="#path-5"></use>
                                </mask>
                                <g id="Clip-25"></g>
                                <path
                                    d="M11.3110714,3.04137931 C10.9018571,2.33775862 10.3627143,1.72586207 9.71428571,1.23706897 C8.6955,0.471896552 7.44357143,0 6.07142857,0 C2.72364286,0 0,2.70706897 0,6.03448276 L2.42857143,6.03448276 C2.42857143,4.03827586 4.06178571,2.4137931 6.07142857,2.4137931 C6.82914286,2.4137931 7.53342857,2.64551724 8.11628571,3.04137931 C9.07921429,3.69431034 9.71428571,4.79137931 9.71428571,6.03448276 C9.71428571,8.03068966 8.07985714,9.65517241 6.07142857,9.65517241 C5.39992857,9.65517241 4.85714286,10.1946552 4.85714286,10.862069 C4.85714286,11.5294828 5.39992857,12.0689655 6.07142857,12.0689655 C9.41921429,12.0689655 12.1428571,9.36189655 12.1428571,6.03448276 C12.1428571,4.93982759 11.8259286,3.92724138 11.3110714,3.04137931"
                                    id="Fill-24"
                                    fill="#BDC3C7"
                                    mask="url(#mask-6)"
                                ></path>
                            </g>
                            <mask id="mask-8" fill="white">
                                <use xlinkHref="#path-7"></use>
                            </mask>
                            <g id="Clip-28"></g>
                            <polygon
                                id="Fill-27"
                                fill="#F0EDE0"
                                mask="url(#mask-8)"
                                points="0 70 68 70 68 21.7241379 0 21.7241379"
                            ></polygon>
                        </g>
                    </g>
                    <g id="Group-5" transform="translate(17.000000, 28.160920)">
                        <path
                            d="M34,16.8965517 C34,26.2281793 26.38876,33.7931034 17,33.7931034 C7.61124,33.7931034 0,26.2281793 0,16.8965517 C0,7.56492414 7.61124,0 17,0 C26.38876,0 34,7.56492414 34,16.8965517"
                            id="Fill-1"
                            fill="#3DA50C"
                        ></path>
                        <polyline
                            id="Stroke-3"
                            stroke="#FFFFFF"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            points="25.84 10.137931 14.96 22.3034483 8.16 16.8965517"
                        ></polyline>
                    </g>
                </g>
            </g>
        </g>
    </svg>
)

export const apptRescheduleIcon = () => (
    <svg
        width="68px"
        height="70px"
        viewBox="0 0 68 70"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <title>icon-reschedule</title>
        <defs>
            <polygon id="path-1" points="0 0 9.71428571 0 9.71428571 12.0689655 0 12.0689655"></polygon>
            <polygon id="path-3" points="0 0 9.71428571 0 9.71428571 12.0689655 0 12.0689655"></polygon>
            <polygon id="path-5" points="0 0 12.1428571 0 12.1428571 12.0689655 0 12.0689655"></polygon>
            <polygon id="path-7" points="0 70 68 70 68 0 0 0"></polygon>
        </defs>
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="icon" transform="translate(-137.000000, -472.000000)">
                <g id="icon-reschedule" transform="translate(137.000000, 472.000000)">
                    <polygon id="Fill-1" fill="#25C3AA" points="49.7866033 6 18.214611 6 0 6 0 22 68 22 68 6"></polygon>
                    <g id="Group-37">
                        <path
                            d="M25.5,10.862069 C25.5,12.1956897 24.4132143,13.2758621 23.0714286,13.2758621 C21.7296429,13.2758621 20.6428571,12.1956897 20.6428571,10.862069 C20.6428571,9.52844828 21.7296429,8.44827586 23.0714286,8.44827586 C24.4132143,8.44827586 25.5,9.52844828 25.5,10.862069"
                            id="Fill-2"
                            fill="#485762"
                        ></path>
                        <path
                            d="M32.7857143,10.862069 C32.7857143,12.1956897 31.6989286,13.2758621 30.3571429,13.2758621 C29.0153571,13.2758621 27.9285714,12.1956897 27.9285714,10.862069 C27.9285714,9.52844828 29.0153571,8.44827586 30.3571429,8.44827586 C31.6989286,8.44827586 32.7857143,9.52844828 32.7857143,10.862069"
                            id="Fill-4"
                            fill="#485762"
                        ></path>
                        <path
                            d="M40.0714286,10.862069 C40.0714286,12.1956897 38.9846429,13.2758621 37.6428571,13.2758621 C36.3010714,13.2758621 35.2142857,12.1956897 35.2142857,10.862069 C35.2142857,9.52844828 36.3010714,8.44827586 37.6428571,8.44827586 C38.9846429,8.44827586 40.0714286,9.52844828 40.0714286,10.862069"
                            id="Fill-6"
                            fill="#485762"
                        ></path>
                        <path
                            d="M47.3571429,10.862069 C47.3571429,12.1956897 46.2703571,13.2758621 44.9285714,13.2758621 C43.5867857,13.2758621 42.5,12.1956897 42.5,10.862069 C42.5,9.52844828 43.5867857,8.44827586 44.9285714,8.44827586 C46.2703571,8.44827586 47.3571429,9.52844828 47.3571429,10.862069"
                            id="Fill-8"
                            fill="#485762"
                        ></path>
                        <path
                            d="M44.9285714,0 C43.5564286,0 42.3032857,0.471896552 41.2857143,1.23706897 C41.9341429,1.72586207 42.4745,2.33775862 42.8825,3.04137931 C43.4665714,2.64551724 44.1708571,2.4137931 44.9285714,2.4137931 C46.937,2.4137931 48.5714286,4.03827586 48.5714286,6.03448276 C48.5714286,8.03068966 46.937,9.65517241 44.9285714,9.65517241 C44.2570714,9.65517241 43.7142857,10.1946552 43.7142857,10.862069 C43.7142857,11.5294828 44.2570714,12.0689655 44.9285714,12.0689655 C48.2763571,12.0689655 51,9.36189655 51,6.03448276 C51,2.70706897 48.2763571,0 44.9285714,0"
                            id="Fill-10"
                            fill="#BDC3C7"
                        ></path>
                        <path
                            d="M39.6885643,3.04137931 C39.1737071,3.92724138 38.8567786,4.93982759 38.8567786,6.03448276 L41.28535,6.03448276 C41.28535,4.79137931 40.6514929,3.69431034 39.6885643,3.04137931"
                            id="Fill-12"
                            fill="#95A5A5"
                        ></path>
                        <path
                            d="M32.40285,3.04137931 C31.8879929,3.92724138 31.5710643,4.93982759 31.5710643,6.03448276 L33.9996357,6.03448276 C33.9996357,4.79137931 33.3657786,3.69431034 32.40285,3.04137931"
                            id="Fill-14"
                            fill="#95A5A5"
                        ></path>
                        <g id="Group-18" transform="translate(34.000364, 0.000000)">
                            <mask id="mask-2" fill="white">
                                <use xlinkHref="#path-1"></use>
                            </mask>
                            <g id="Clip-17"></g>
                            <path
                                d="M8.8825,3.04137931 C8.47328571,2.33775862 7.93414286,1.72586207 7.28571429,1.23706897 C6.26692857,0.471896552 5.015,0 3.64285714,0 C2.27071429,0 1.01757143,0.471896552 0,1.23706897 C0.648428571,1.72586207 1.18757143,2.33775862 1.59678571,3.04137931 C2.18085714,2.64551724 2.88392857,2.4137931 3.64285714,2.4137931 C4.40057143,2.4137931 5.10485714,2.64551724 5.68771429,3.04137931 C6.65064286,3.69431034 7.28571429,4.79137931 7.28571429,6.03448276 C7.28571429,8.03068966 5.65128571,9.65517241 3.64285714,9.65517241 C2.97135714,9.65517241 2.42857143,10.1946552 2.42857143,10.862069 C2.42857143,11.5294828 2.97135714,12.0689655 3.64285714,12.0689655 C6.99064286,12.0689655 9.71428571,9.36189655 9.71428571,6.03448276 C9.71428571,4.93982759 9.39735714,3.92724138 8.8825,3.04137931"
                                id="Fill-16"
                                fill="#BDC3C7"
                                mask="url(#mask-2)"
                            ></path>
                        </g>
                        <path
                            d="M25.1171357,3.04137931 C24.6022786,3.92724138 24.28535,4.93982759 24.28535,6.03448276 L26.7139214,6.03448276 C26.7139214,4.79137931 26.0800643,3.69431034 25.1171357,3.04137931"
                            id="Fill-19"
                            fill="#95A5A5"
                        ></path>
                        <g id="Group-23" transform="translate(26.714650, 0.000000)">
                            <mask id="mask-4" fill="white">
                                <use xlinkHref="#path-3"></use>
                            </mask>
                            <g id="Clip-22"></g>
                            <path
                                d="M8.8825,3.04137931 C8.47328571,2.33775862 7.93414286,1.72586207 7.28571429,1.23706897 C6.26692857,0.471896552 5.015,0 3.64285714,0 C2.27071429,0 1.01757143,0.471896552 0,1.23706897 C0.648428571,1.72586207 1.18757143,2.33775862 1.59678571,3.04137931 C2.18085714,2.64551724 2.88392857,2.4137931 3.64285714,2.4137931 C4.40057143,2.4137931 5.10485714,2.64551724 5.68771429,3.04137931 C6.65064286,3.69431034 7.28571429,4.79137931 7.28571429,6.03448276 C7.28571429,8.03068966 5.65128571,9.65517241 3.64285714,9.65517241 C2.97135714,9.65517241 2.42857143,10.1946552 2.42857143,10.862069 C2.42857143,11.5294828 2.97135714,12.0689655 3.64285714,12.0689655 C6.99064286,12.0689655 9.71428571,9.36189655 9.71428571,6.03448276 C9.71428571,4.93982759 9.39735714,3.92724138 8.8825,3.04137931"
                                id="Fill-21"
                                fill="#BDC3C7"
                                mask="url(#mask-4)"
                            ></path>
                        </g>
                        <g id="Group-26" transform="translate(17.000364, 0.000000)">
                            <mask id="mask-6" fill="white">
                                <use xlinkHref="#path-5"></use>
                            </mask>
                            <g id="Clip-25"></g>
                            <path
                                d="M11.3110714,3.04137931 C10.9018571,2.33775862 10.3627143,1.72586207 9.71428571,1.23706897 C8.6955,0.471896552 7.44357143,0 6.07142857,0 C2.72364286,0 0,2.70706897 0,6.03448276 L2.42857143,6.03448276 C2.42857143,4.03827586 4.06178571,2.4137931 6.07142857,2.4137931 C6.82914286,2.4137931 7.53342857,2.64551724 8.11628571,3.04137931 C9.07921429,3.69431034 9.71428571,4.79137931 9.71428571,6.03448276 C9.71428571,8.03068966 8.07985714,9.65517241 6.07142857,9.65517241 C5.39992857,9.65517241 4.85714286,10.1946552 4.85714286,10.862069 C4.85714286,11.5294828 5.39992857,12.0689655 6.07142857,12.0689655 C9.41921429,12.0689655 12.1428571,9.36189655 12.1428571,6.03448276 C12.1428571,4.93982759 11.8259286,3.92724138 11.3110714,3.04137931"
                                id="Fill-24"
                                fill="#BDC3C7"
                                mask="url(#mask-6)"
                            ></path>
                        </g>
                        <mask id="mask-8" fill="white">
                            <use xlinkHref="#path-7"></use>
                        </mask>
                        <g id="Clip-28"></g>
                        <polygon
                            id="Fill-27"
                            fill="#F0EDE0"
                            mask="url(#mask-8)"
                            points="0 70 68 70 68 21.7241379 0 21.7241379"
                        ></polygon>
                        <path
                            d="M20.6428571,35 C20.6428571,38.3322414 17.9240714,41.0344828 14.5714286,41.0344828 C11.2187857,41.0344828 8.5,38.3322414 8.5,35 C8.5,31.6677586 11.2187857,28.9655172 14.5714286,28.9655172 C17.9240714,28.9655172 20.6428571,31.6677586 20.6428571,35"
                            id="Fill-29"
                            fill="#D6D1BB"
                            mask="url(#mask-8)"
                        ></path>
                        <path
                            d="M40.0714286,35 C40.0714286,38.3322414 37.3526429,41.0344828 34,41.0344828 C30.6473571,41.0344828 27.9285714,38.3322414 27.9285714,35 C27.9285714,31.6677586 30.6473571,28.9655172 34,28.9655172 C37.3526429,28.9655172 40.0714286,31.6677586 40.0714286,35"
                            id="Fill-30"
                            fill="#D6D1BB"
                            mask="url(#mask-8)"
                        ></path>
                        <path
                            d="M59.5,35 C59.5,38.3322414 56.7812143,41.0344828 53.4285714,41.0344828 C50.0759286,41.0344828 47.3571429,38.3322414 47.3571429,35 C47.3571429,31.6677586 50.0759286,28.9655172 53.4285714,28.9655172 C56.7812143,28.9655172 59.5,31.6677586 59.5,35"
                            id="Fill-31"
                            fill="#D6D1BB"
                            mask="url(#mask-8)"
                        ></path>
                        <path
                            d="M20.6428571,54.3103448 C20.6428571,57.6425862 17.9240714,60.3448276 14.5714286,60.3448276 C11.2187857,60.3448276 8.5,57.6425862 8.5,54.3103448 C8.5,50.9781034 11.2187857,48.2758621 14.5714286,48.2758621 C17.9240714,48.2758621 20.6428571,50.9781034 20.6428571,54.3103448"
                            id="Fill-32"
                            fill="#FF0000"
                            mask="url(#mask-8)"
                        ></path>
                        <path
                            d="M40.0714286,54.3103448 C40.0714286,57.6425862 37.3526429,60.3448276 34,60.3448276 C30.6473571,60.3448276 27.9285714,57.6425862 27.9285714,54.3103448 C27.9285714,50.9781034 30.6473571,48.2758621 34,48.2758621 C37.3526429,48.2758621 40.0714286,50.9781034 40.0714286,54.3103448"
                            id="Fill-33"
                            fill="#D6D1BB"
                            mask="url(#mask-8)"
                        ></path>
                        <path
                            d="M59.5,54.3103448 C59.5,57.6425862 56.7812143,60.3448276 53.4285714,60.3448276 C50.0759286,60.3448276 47.3571429,57.6425862 47.3571429,54.3103448 C47.3571429,50.9781034 50.0759286,48.2758621 53.4285714,48.2758621 C56.7812143,48.2758621 59.5,50.9781034 59.5,54.3103448"
                            id="Fill-34"
                            fill="#25C3AB"
                            mask="url(#mask-8)"
                        ></path>
                        <path
                            d="M15.7084857,46.002069 C15.7084857,45.9827586 15.7097,45.9634483 15.7109143,45.9441379 C16.1504857,41.7936207 18.0253429,37.8881034 20.9894143,34.9481034 C23.9534857,32.0201724 27.8950571,30.1832759 32.0879857,29.772931 C36.2857714,29.3903448 40.5054143,30.4536207 43.9746286,32.7660345 C47.4511286,35.1110345 50.0314857,38.5953448 51.2445571,42.5793103 C51.3004143,42.805 51.3526286,43.0017241 51.4048429,43.1984483 C51.5505571,43.7451724 51.6999143,44.3112069 51.7642714,44.905 C51.7800571,45.0184483 51.8019143,45.1487931 51.8225571,45.2791379 C51.8626286,45.5337931 51.9039143,45.7872414 51.9269857,46.0431034 L51.9864857,47.2053448 C52.0022714,47.5034483 51.7703429,47.7593103 51.4692,47.7737931 C51.1692714,47.7894828 50.9130571,47.5589655 50.8984857,47.2608621 L50.8402,46.1203448 C50.8207714,45.9103448 50.7831286,45.6810345 50.7454857,45.4505172 C50.7236286,45.312931 50.7017714,45.1753448 50.6823429,45.0365517 C50.6252714,44.507931 50.4917,44.0058621 50.3508429,43.4748276 C50.2962,43.272069 50.2427714,43.0681034 50.1929857,42.862931 C49.0612714,39.1456897 46.6327,35.8677586 43.3650571,33.6639655 C40.1059143,31.4915517 36.1364143,30.4922414 32.1912,30.8518966 C28.2508429,31.2368966 24.5436286,32.9639655 21.7580571,35.7156897 C18.9712714,38.4794828 17.2081286,42.1532759 16.7952714,46.0575862 C16.7637,46.3556897 16.4953429,46.5717241 16.1966286,46.5403448 C15.9161286,46.5113793 15.7084857,46.2760345 15.7084857,46.002069"
                            id="Fill-35"
                            fill="#002552"
                            mask="url(#mask-8)"
                        ></path>
                        <path
                            d="M48.3339143,44.4794483 C48.3339143,44.3599655 48.3727714,44.2404828 48.4541286,44.1403103 C48.6423429,43.9073793 48.9859857,43.8699655 49.2203429,44.0582414 C49.6368429,44.3913448 49.9926286,44.7485862 50.3678429,45.1275517 L50.7017714,45.4642759 C50.7892,45.5547931 50.8778429,45.6453103 50.9604143,45.7382414 L51.2712714,46.1232414 C51.3101286,46.1715172 51.3489857,46.221 51.3878429,46.2704828 C51.4194143,46.2161724 51.4509857,46.1618621 51.4837714,46.1075517 L51.7363429,45.6646207 C51.7776286,45.5837586 51.8225571,45.4835862 51.8699143,45.3822069 L52.0642,44.948931 C52.2937,44.4347931 52.5317,43.9025517 52.7053429,43.3691034 C52.7976286,43.0842759 53.1036286,42.9273793 53.3902,43.0191034 C53.6767714,43.1108276 53.8346286,43.4149655 53.7423429,43.6997931 C53.5517,44.2899655 53.3015571,44.8487586 53.0599143,45.3882414 L52.8607714,45.8311724 C52.8073429,45.9482414 52.7539143,46.0641034 52.6944143,46.1787586 L52.4297,46.6458276 C52.2548429,46.9463448 52.0799857,47.236 51.9063429,47.5172069 C51.8116286,47.6704828 51.6464857,47.7658276 51.4667714,47.7742759 C51.2858429,47.7827241 51.1134143,47.7006552 51.0053429,47.5570345 C50.8098429,47.2963448 50.6143429,47.0428966 50.4188429,46.7991034 L50.1249857,46.4358276 C50.0703429,46.373069 49.9938429,46.2946207 49.9185571,46.2173793 L49.5931286,45.8878966 C49.2397714,45.5318621 48.9058429,45.1963448 48.5379143,44.9018621 C48.4031286,44.7944483 48.3339143,44.6375517 48.3339143,44.4794483"
                            id="Fill-36"
                            fill="#002552"
                            mask="url(#mask-8)"
                        ></path>
                    </g>
                </g>
            </g>
        </g>
    </svg>
)

export const mailIcon = () => (
    <svg
        width="20px"
        height="18px"
        viewBox="0 0 20 18"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <title>icon-mail</title>
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="icon" transform="translate(-484.000000, -498.000000)" fill="#FFFFFF" fill-rule="nonzero">
                <path
                    d="M502.015625,503.015625 L502.015625,501 L494,506.015625 L485.984375,501 L485.984375,503.015625 L494,507.984375 L502.015625,503.015625 Z M502.015625,498.984375 C502.546875,498.984375 503.007812,499.1875 503.398438,499.59375 C503.789062,500 503.984375,500.46875 503.984375,501 L503.984375,513 C503.984375,513.53125 503.789062,514 503.398438,514.40625 C503.007812,514.8125 502.546875,515.015625 502.015625,515.015625 L485.984375,515.015625 C485.453125,515.015625 484.992188,514.8125 484.601562,514.40625 C484.210938,514 484.015625,513.53125 484.015625,513 L484.015625,501 C484.015625,500.46875 484.210938,500 484.601562,499.59375 C484.992188,499.1875 485.453125,498.984375 485.984375,498.984375 L502.015625,498.984375 Z"
                    id="icon-mail"
                ></path>
            </g>
        </g>
    </svg>
)
